
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/service-management/documents/login-method",
      function () {
        return require("private-next-pages/service-management/documents/login-method/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/service-management/documents/login-method"])
      });
    }
  